import { Singleton } from '@tunein/web-utils';
class PlayerSingleton extends Singleton {
    #isAdBreak = false;
    #didPlayPreroll = false;
    init(instance) {
        this.instance = instance;
    }
    get isAdBreak() {
        return this.#isAdBreak;
    }
    set isAdBreak(isAdBreak) {
        this.#isAdBreak = isAdBreak;
    }
    get didPlayPreroll() {
        return this.#didPlayPreroll;
    }
    set didPlayPreroll(didPlayPreroll) {
        this.#didPlayPreroll = didPlayPreroll;
    }
    get isBoostStream() {
        return this.instance.currentSource?.isBoostStream ?? false;
    }
    get isBoostIntroStream() {
        return this.instance.currentSource?.isBoostIntroStream ?? false;
    }
    get isBoostOrIntroStream() {
        return this.isBoostStream || this.isBoostIntroStream;
    }
    get isBoostOutroStream() {
        return this.instance.currentSource?.isBoostOutroStream ?? false;
    }
    get isBoostTransitionStream() {
        return this.isBoostIntroStream || this.isBoostOutroStream;
    }
    get isLiveSeekStream() {
        return this.instance.currentSource?.isLiveSeekStream ?? false;
    }
}
export const player = new PlayerSingleton();
